import { render, staticRenderFns } from "./MasterRplLainya.vue?vue&type=template&id=740606c2&"
import script from "./MasterRplLainya.vue?vue&type=script&lang=js&"
export * from "./MasterRplLainya.vue?vue&type=script&lang=js&"
import style0 from "./MasterRplLainya.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports